import { useEffect } from 'react';
import { useColorBlindStateUpdater } from './useColorBlindStateUpdater';

/**
 * Keeps the Trello root classes in sync with colorBlindState.
 * Meant to be a singleton; currently _only_ used in TrelloOnline.
 */
export const useColorBlindDOMMutations = () => {
  const isColorBlind = useColorBlindStateUpdater();

  const colorBlindEnabledClass = 'body-color-blind-mode-enabled';
  const newColorBlindPatternsClass = 'body-new-color-blind-mode-patterns';

  useEffect((): void => {
    const trelloRoot = document.getElementById('trello-root')!;

    if (!trelloRoot) {
      return;
    }

    if (isColorBlind) {
      trelloRoot.classList.add(colorBlindEnabledClass);
      trelloRoot.classList.add(newColorBlindPatternsClass);
    } else {
      trelloRoot.classList.remove(colorBlindEnabledClass);
      trelloRoot.classList.remove(newColorBlindPatternsClass);
    }
  }, [isColorBlind]);

  return null;
};
